export const calcReason = (itemsToPay) => {
  let result = "";
  itemsToPay.map((it) => {
    if (it.description && it.description.details) {
      if (it.description.details.indexOf("Pagamento fattura ") > -1) {
        result += `${result.length > 0 ? ", " : ""}${it.description.details.split(result.length > 0 ? "Pagamento fattura " : "Pagamento ")[1]}`;
      }
    }
    return null;
  });
  if (result.length > 1) {
    result = `${result.substr(0, 1).toUpperCase()}${result.substr(1, result.length - 1)}`;
  }
  result = result.substr(0, 140);
  return result;
};

export const getFirstTotal = (location) => {
  
  let amount = 0;
  if (location.state && location.state.from !== "documents") {
    if (location.state.deadlines.length > 1) {
      amount = location.state.deadlines.reduce((a, b) => {
        return (typeof a === "object" ? a.totalAmount : a) + b.totalAmount;
      });
    } else if (location.state.deadlines.length === 1) {
      amount = location.state.deadlines[0].totalAmount;
    } 
   
  }
  if (amount < 0) {
    amount = amount * -1;
  }
  return amount;
};
